var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.rating)?_c('div',{staticClass:"d-flex"},_vm._l((parseInt(_vm.data.rating)),function(n){return _c('i',{key:n,staticClass:"fa fa-star text-success"})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }